<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex flex-wrap flex-wrap align-items-center justify-content-center mb-3">
					<div class="text-center">
						<h4 class="mb-3">{{ title }}</h4>
						<p class="mb-0">{{ desc1 }}<br> {{ desc2 }}<br>{{ desc3 }}</p>
						<p v-b-modal.modal-3 variant="link" class="mb-0"><u>수집이 잘 되지 않는 경우 조치방법</u></p>
						<b-modal id="modal-3" size="xl" title="수집이 잘 되지 않는 경우 조치방법" ok-only>
							<p v-for="(tip, i) in collectTips" :key="i">{{ i + 1 }}. {{ tip }}</p>
						</b-modal>
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="d-flex justify-content-center h-100">
					<input ref="cursor" type="text" class="form-control w-25 h-100 text-center rounded-pill"
						placeholder="키워드 추가 (콤마로 구분하여 여러개 입력 가능)" v-model="targetKeyword" @keyup.enter="addKeyword($event)"
						@change="keyinkeywords">
				</div>
			</div>
			<div class="col-lg-12 d-flex justify-content-center align-items-center" v-if="showspinner">
				<div class="custom-control custom-control-inline d-flex justify-content-center">
					<div class="row">
						<div class="col-12">
							<img style="max-width:50px;" :src="require('../../../assets/images/small/loading.gif')">
							<span>{{ loadingtext }}... {{ loadingrate }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 d-flex justify-content-center align-items-center border">
				<b-badge variant="primary text-center">키워드 수집</b-badge>
				<div class="ml-3 pl-2 border-left">
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.relKeyword>연관+자동완성</button>
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.keywordRank>네이버데이터랩</button>
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.excelupload>대량업로드</button>
				</div>
			</div>

			<div class="col-lg-12 d-flex justify-content-center align-items-center border-left border-right border-bottom">
				<b-badge variant="success text-center">키워드 분석 옵션</b-badge>
				<div class="ml-3 pl-3 border-left" style="font-size:80%">
					<!-- <div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-1"
								v-model="check1" @change="checkShowItems">
							<label class="custom-control-label" for="customCheck-1"> 기본 키워드 분석 (쿠팡/네이버 1페이지 분석)</label>
						</div>
					</div> -->
					<div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-2"
								v-model="check2" @change="checkShowItems">
							<label class="custom-control-label" for="customCheck-2"> 상세 분석 (광고비율, 광고상품수, 광고구좌수 등)</label>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 d-flex justify-content-center align-items-center border-left border-right border-bottom"
				v-if="this.keywords.length > 0">
				<button type="button" class="btn btn-outline-primary" @click="search">키워드 분석 시작</button>
				<button type="button" class="btn btn-outline-secondary ml-2" @click="deleteKeywords">삭제</button>
				<button type="button" class="btn btn-outline-success ml-2" @click="downloadKeywords">다운로드</button>
			</div>

			<b-modal :id="'relKeyword'" size="xl" title="쿠팡 연관+자동완성 키워드 수집" ok-title="수집하기" cancel-title="취소"
				@ok="collectRelKeyword">
				<div class="row">
					<div class="col-md-12 d-flex justify-content-center">
						<input ref="cursor" type="text" class="form-control text-center rounded-pill"
							placeholder="검색키워드" v-model="targetKeyword" @keyup.enter="collectRelKeywordEnter($event)">
					</div>
					<div class="col-md-12 d-flex align-items-center justify-content-start">
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-18"
								v-model="relKeywordChecked">
							<label class="custom-control-label" for="customCheck-18"> 연관키워드</label>
						</div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-17"
								v-model="autoCompleteChecked">
							<label class="custom-control-label" for="customCheck-17"> 자동완성키워드</label>
						</div>
						<div class="ml-4">
							반복횟수
						</div>
						<div class="custom-control-inline ml-3 d-flex justify-content-start">
							<input type="number" :min="1" :max="500" class="form-control text-center" placeholder=""
								aria-label="" v-model="relCycle">
						</div>
					</div>
				</div>
			</b-modal>

			<b-modal :id="'keywordRank'" size="xl" title="네이버 데이터랩 키워드 수집" ok-title="수집하기" cancel-title="취소"
				@ok="collectKeyword">
				<div class="row">
					<div class="col-md-12 mt-2 d-flex align-items-center justify-content-between">
						<div style="font-size:85%"><b>[수집할 키워드 순위설정]</b><br>새탭에 네이버 데이터랩 쇼핑인사이트<br>Top500키워드가 나오도록 먼저
							세팅해주세요</div>
						<div class="custom-control-inline ml-3 d-flex justify-content-center">
							<input type="number" :min="1" :max="500" class="form-control" placeholder="" aria-label=""
								v-model="startRank" style="text-align:center;">
							~
							<input type="number" :min="1" :max="500" class="form-control" placeholder="" aria-label=""
								v-model="endRank" style="text-align:center;">
						</div>
					</div>
				</div>
			</b-modal>

			<b-modal size="xl" id="excelupload" scrollable title="키워드대량업로드" ok-only>
				<div class="row">
					<div class="col-md-12">
						<p>[업로드 방법]</p>
						<p>1. 엑셀업로드 포맷 다운로드<br>
							2. 엑셀 파일에서 키워드 부분(맨윗줄 제외) 업데이트<br>
							3. 업데이트된 엑셀 파일 업로드 순으로 진행해 주세요.</p>
					</div>
					<div class="col-md-12 mt-4">
						<div class="form-group">
							<label>1. 엑셀업로드 포맷</label>
							<div>
								<button type="reset" @click="formatDownload"
									class="btn btn-primary mr-2">Download</button>
							</div>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label for="Code">2. 업데이트된 구매요청양식 업로드</label>
							<div class="custom-file">
								<input ref="pdbupload" type="file" @change="uploadfile" class="custom-file-input"
									id="inputGroupFile02">
								<label class="custom-file-label" for="inputGroupFile02">{{ uploadstatus }}</label>
							</div>
							<div class="col-md-12" v-if="showuploadspinner">
								<div>
									<img style="width:5%;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>



			<div class="col-lg-12 mt-4">
				<div class="d-flex justify-content-between align-items-center mb-3">
					<div>
						<span class="text-muted">총 {{ keywords.length }}개의 키워드</span>
					</div>
					<div>
						<button type="button" class="btn btn-outline-danger btn-sm mr-2" @click="deleteKeywords">
							<i class="fa fa-trash"></i> 선택삭제
						</button>
						<button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="clearAllKeywords">
							<i class="fa fa-trash-alt"></i> 전체삭제
						</button>
						<button type="button" class="btn btn-outline-success btn-sm" @click="downloadKeywords">
							<i class="fa fa-download"></i> 다운로드
						</button>
					</div>
				</div>
				<CDataTable
					storage-key="keywordAnalysis" :headers="headers" :items="keywords" v-model="tableSelectedItem" :show-select="true"
					itemKey="keyword" style="margin-bottom: 10px" v-if="showlist">
					<template v-slot:add="{ item }">
						<div v-if="!item.add">
							<button type="button" class="btn btn-outline-primary ml-2"
							@click="addRelKeyword(item)">+</button>
						</div>
					</template>
					<template v-slot:del="{ item }">
						<button type="button" class="btn btn-outline-secondary ml-2"
							@click="deleteKeyword(item)">x</button>
					</template>
					<template v-for="header in slotHeaders" v-bind:slot="header.value" slot-scope="{ item }">
						{{ typeof item[header.value] === 'number' ? item[header.value]?.toLocaleString() :
							item[header.value] }}
					</template>
				</CDataTable>
			</div>
		</div>
		<!-- Page end  -->
	</div>
</template>
<script>
import axios from 'axios';
import { EXT_COLLECT_TIPS } from '@/utils/extInstallSteps';
import * as XLSX from 'xlsx';
import CDataTable from "@/components/common/CDataTable";
import IndexedDBStore from '@/components/common/IndexedDB';

export default {
	name:'keywordAnalysis',
	data(){
		return{
			collectTips: EXT_COLLECT_TIPS,
			headers: [
				{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
				{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
				{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true },
				{ text: '윙상품비율(%)', value: 'wingrate', align: 'center', width: 100, isSlot: true },
				{ text: '1p윙상품수', value: 'wing1p', align: 'center', width: 100, isSlot: true },
				{ text: '1p로켓상품수', value: 'rocket1p', align: 'center', width: 100, isSlot: true },
				{ text: '1p그로스상품수', value: 'growth1p', align: 'center', width: 100, isSlot: true },
				{ text: '광고비율(%)', value: 'adrate', align: 'center', width: 100, isSlot: true },
				{ text: '광고상품수', value: 'adqty', align: 'center', width: 100, isSlot: true },
				{ text: '광고구좌수', value: 'adplace', align: 'center', width: 100, isSlot: true },
				{ text: 'CPC단가_추천', value: 'cpc', align: 'center', width: 100, isSlot: true },
				{ text: 'CPC단가_최대', value: 'cpchigh', align: 'center', width: 100, isSlot: true },
				{ text: 'CPC단가_최저', value: 'cpclow', align: 'center', width: 100, isSlot: true },
				{ text: '전체상품수', value: 'totalqty', align: 'center', width: 100, isSlot: true },
				{ text: '최대리뷰수', value: 'review1phigh', align: 'center', width: 100, isSlot: true },
				{ text: '평균리뷰수', value: 'review1p', align: 'center', width: 100, isSlot: true },
				{ text: '중간리뷰수', value: 'review1pmiddle', align: 'center', width: 100, isSlot: true },
				{ text: '최저리뷰수', value: 'review1plow', align: 'center', width: 100, isSlot: true },
				{ text: '최대판매가', value: 'price1phigh', align: 'center', width: 100, isSlot: true },
				{ text: '평균판매가', value: 'price1p', align: 'center', width: 100, isSlot: true },
				{ text: '중간판매가', value: 'price1pmiddle', align: 'center', width: 100, isSlot: true },
				{ text: '최저판매가', value: 'price1plow', align: 'center', width: 100, isSlot: true },
				{ text: '네이버최대판매가', value: 'pricen1phigh', align: 'center', width: 120, isSlot: true },
				{ text: '네이버평균판매가', value: 'pricen1p', align: 'center', width: 120, isSlot: true },
				{ text: '네이버중간판매가', value: 'pricen1pmiddle', align: 'center', width: 120, isSlot: true },
				{ text: '네이버최저판매가', value: 'pricen1plow', align: 'center', width: 120, isSlot: true },
				{ text: '최대월판매수', value: 'n1psalesqtyhigh', align: 'center', width: 100, isSlot: true },
				{ text: '평균월판매수', value: 'n1psalesqty', align: 'center', width: 100, isSlot: true },
				{ text: '중간월판매수', value: 'n1psalesqtymiddle', align: 'center', width: 100, isSlot: true },
				{ text: '최저월판매수', value: 'n1psalesqtylow', align: 'center', width: 100, isSlot: true },
				{ text: '최대월매출', value: 'n1psaleshigh', align: 'center', width: 100, isSlot: true },
				{ text: '평균월매출', value: 'n1psales', align: 'center', width: 100, isSlot: true },
				{ text: '중간월매출', value: 'n1psalesmiddle', align: 'center', width: 100, isSlot: true },
				{ text: '최저월매출', value: 'n1psaleslow', align: 'center', width: 100, isSlot: true },
			],
			tableSelectedItem: [],
			keywords: [],
			db: null,

			showuploadspinner: false,
			uploadstatus: 'excel file upload',

			check1: true,
			check2: false,
			check3: false,

			relKeywordChecked: true,
			autoCompleteChecked: true,
			relCycle: 1,

			related:false,
			auth:'',
			loadingtext:'연관검색어 분석 중',
			loadingrate:'',

			showspinner:false,
			showlist:true,

			waitresult:false,
			targetKeyword:'',
			fullsearch:false,
			rowlines:[], // 분석 처리용 임시 배열

			title:"키워드 분석",
			desc1:"키워드 수집방법과 분석방법을 선택한 후 분석합니다.",
			desc2:"쿠팡wing, 광고센터를 새탭에서 열고 수집해주세요",
			desc3:"키워드를 분석할 때마다 결과가 아래로 쌓입니다.",
			startRank : 1,
			endRank:500,
		}
	},
	components: {
		CDataTable,
	},
	async created() {
		// IndexedDB 초기화 - keywordAnalysis 전용 스토어 사용
		this.db = new IndexedDBStore('couplustDB', 'keywordAnalysis');
		await this.db.initDB();

		// 저장된 키워드 불러오기
		try {
			const savedKeywords = await this.db.getKeywords();
			if (savedKeywords && savedKeywords.length > 0) {
				// 1) 'keyword' 필드가 제대로 있는 항목만 필터링
				const validKeywords = savedKeywords.filter(item => {
					// item이 null이 아닌지, item.keyword가 존재하는지
					return item && typeof item.keyword === 'string' && item.keyword.trim().length > 0;
				});

				// 2) 필터링 결과가 전체 개수보다 적으면, 즉 "문제 키워드"가 있었다면 DB에도 재저장
				if (validKeywords.length < savedKeywords.length) {
					await this.db.saveKeywords(validKeywords).catch(error => {
						console.error('DB 저장 중 오류:', error);
					});
					console.log('[created] 문제가 있는 키워드들을 제외하고 DB 재저장 완료');
				}

				// 3) 정상 항목만 this.keywords로 세팅
				this.keywords = validKeywords;
				// this.showlist = true;
			}
		} catch (error) {
			console.error('키워드 불러오기 실패:', error);
		}

		// 저장된 분석 결과 불러오기 및 키워드와 통합
		try {
			const savedAnalysisResults = await this.db.getAnalysisResults();
			if (savedAnalysisResults && savedAnalysisResults.length > 0) {
				// 분석 결과를 키워드 목록과 통합
				this.mergeAnalysisResults(savedAnalysisResults);

				// 더 이상 헤더 업데이트 불필요 (모든 컬럼이 처음부터 정의됨)
			}
		} catch (error) {
			console.error('분석 결과 불러오기 실패:', error);
		}
	},
	beforeDestroy() {
		window.removeEventListener('message', this.messageEventHandler);
	},
	computed: {
		slotHeaders() {
			return this.headers.filter(header => header.value !== 'add' && header.value !== 'del' && header.isSlot);
		}
	},
	mounted(){
		this.messageEventHandler = async(event) => {
			if(event.data.res && event.data.res === 'login'){
				alert('새탭에 광고센터를 열어주세요')
				this.showspinner = false;
				return
			}
			if(event.data.res && event.data.res === 'alert'){
				alert(event.data.alert)
				return
			}
			if(event.data.res && event.data.res === 'collectKeyword'){
				if(event.data.keywords && event.data.keywords.length > 0){
					var allKeywords = event.data.keywords;
					for(var keyword of allKeywords){
						if(keyword.replaceAll(" ","").length > 0){
							if(!this.keywords.find(e => e.keyword.replaceAll(" ","") == keyword.replaceAll(" ",""))){
								this.keywords.push({
									keyword: keyword.replaceAll(" ",""),
									add: false,
									del: false,
								})
							}
						}
					}
				}
				// 키워드를 전부 push한 뒤, DB 저장
				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});

				this.$nextTick(() => {
					// this.showlist = true;
					this.showspinner = false;
				});
				return
			}
			if(event.data.res && event.data.res === 'adkeywords'){
				var relatedKeywords = event.data.relatedkeywords;
				console.log(relatedKeywords)
				for(var relKeyword of relatedKeywords){
					console.log(relKeyword, relKeyword.replaceAll(" ",""), !this.keywords.find(e => e.keyword.replaceAll(" ","") == relKeyword.replaceAll(" ","")))
					if(!this.keywords.find(e => e.keyword.replaceAll(" ","") == relKeyword.replaceAll(" ",""))){
						if(relKeyword.replaceAll(" ","").length > 0){
							this.keywords.push({
								keyword: relKeyword.replaceAll(" ",""),
								add: false,
								del: false,
							})
						}
					}
				}
				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});
				this.$nextTick(() => {
					// this.showlist = true;
					this.showspinner = false;
				})
			}
			if(event.data.res && event.data.res === 'datalabKeywordStatus'){
                console.log(event.data.status);
				this.loadingtext = event.data.text;
				this.loadingrate = '(' + (event.data.status*100).toFixed(0) + "%)";
				this.showspinner = true;
            }
			if(event.data.res && event.data.res === 'keywordanalysisstatus'){
                console.log(event.data.status);
				this.loadingtext = '키워드 별 페이지 분석 중';
				this.loadingrate = '(' + (event.data.status*100).toFixed(0) + "%)";
				this.showspinner = true;
            }
			if(event.data.res && event.data.res === 'keywordanalysisstatusratio'){
				console.log(event.data.status);
				this.showspinner = true;
				this.loadingtext = event.data.text;
				this.loadingrate = '(' + (event.data.status*100).toFixed(0) + "%)";
				return
			}
            if(event.data.res && event.data.res === 'keywordanalysis'){
				if(!event.data.cpc){
					alert('CPC단가는 쿠팡wing에 로그인 후 정상적으로 출력됩니다.')
				}
                console.log(event.data.coupang);
				console.log(event.data.naver);
				console.log(event.data.cpc);

				this.loadingtext = '데이터 계산 중';
				this.loadingrate = "";
				this.showspinner = true;
				this.showlist = false; // keywordCollect 방식: 처리 중에는 숨기기
				this.makerowlines(event.data.coupang,event.data.naver,event.data.cpc);
            }
            if(event.data.res && event.data.res === 'relatedkeywords'){
                console.log(event.data.relatedkeywords)
				var arr = event.data.relatedkeywords;
				var ar = [];
				if(this.related){
					ar = [this.targetKeyword]
				}
				// console.log(arr)
				arr.forEach(ele => {
					if(!ar.includes(ele)){
						ar.push(ele)
					}
				})
				var keywords = [];
				// console.log(ar)
				ar.forEach(ele => {
					if(!this.rowlines.find(element => element.targetKeyword == ele)){
						keywords.push(ele);
					}
				})
				// console.log(keywords)
				// this.rowlines = [];
				var cnt = 0
				for(var i=0;i<keywords.length;i++){
					cnt++
					this.rowlines.push({
						targetKeyword:keywords[i],
						wing1p:'',
						rocket1p:'',
						growth1p:'',
						adrate:'',
						adqty:'',
						adplace:'',
						cpc:'',
						cpchigh:'',
						cpclow:'',
						rocketrate:'',
						rocketqty:'',
						totalqty:'',
						crate:'',
						review1p:'',
						review1phigh:'',
						review1plow:'',
						review1pmiddle:'',
						n1psalesqty:'',
						n1psalesqtyhigh:'',
						n1psalesqtylow:'',
						n1psalesqtymiddle:'',
						n1psales:'',
						n1psaleshigh:'',
						n1psaleslow:'',
						n1psalesmiddle:'',

						nrate:'',
						pricen1phigh:'',
						pricen1plow:'',
						pricen1p:'',
						pricen1pmiddle:'',
						price1phigh:'',
						price1plow:'',
						price1p:'',
						price1pmiddle:'',
						wingrate:'',
					})

				}
				if(cnt == keywords.length){
					this.importresults(keywords)
				}
            }
        }
		window.addEventListener('message', this.messageEventHandler);

		console.log(navigator)
		this.getauthNo()
		this.startfocus();
	},
	methods: {

		mergeAnalysisResults(analysisResults) {
			// 분석 결과를 키워드 목록과 통합
			for (const result of analysisResults) {
				const keyword = this.keywords.find(k => k.keyword === result.targetKeyword);
				if (keyword) {
					// 기존 키워드에 분석 결과 데이터 추가
					Object.assign(keyword, result);
				} else {
					// 새로운 키워드로 추가 (분석 결과만 있는 경우)
					this.keywords.push({
						keyword: result.targetKeyword,
						add: false,
						del: false,
						...result
					});
				}
			}
		},
		keyinkeywords() {
			if (this.targetKeyword.length > 10 && this.targetKeyword.split(' ').length > 2) {
				console.log(this.targetKeyword.split(' '))
			}
		},
		async clearKeywords() {
			try {
				await this.db.clearKeywords();
				this.keywords = [];
				// this.showlist = false;
				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});
			} catch (error) {
				console.error('키워드 삭제 실패:', error);
			}
		},


		deleteKeyword(item) {
			var i = this.keywords.findIndex(e => e.keyword == item.keyword);
			if (i !== -1) {
				this.keywords = this.keywords.slice(0, i).concat(this.keywords.slice(i + 1));
				const selIndex = this.tableSelectedItem.indexOf(item);
				if (selIndex !== -1) {
					this.tableSelectedItem.splice(selIndex, 1);
				}
				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});
			}

			if (this.keywords.length == 0) {
				// this.showlist = false;
			}
		},
		collectRelKeyword() {
			if (!this.targetKeyword) {
				alert('수집할 검색키워드를 입력해 주세요')
				return
			}
			if (!this.relKeywordChecked && !this.autoCompleteChecked) {
				alert('연관 또는 자동완성 키워드를 체크해 주세요')
				return
			}
			window.postMessage({ greeting: "getadkeyword", data: [this.targetKeyword], cnt: this.relCycle, relKeywordChecked: this.relKeywordChecked, autoCompleteChecked: this.autoCompleteChecked }, "*");
			this.loadingtext = '연관/자동완성 키워드 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
		},
		addRelKeyword(item) {
			window.postMessage({ greeting: "getadkeyword", data: [item.keyword], cnt: 1, relKeywordChecked: true, autoCompleteChecked: true }, "*");
			item.add = true;
			this.loadingtext = '연관/자동완성 키워드 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
		},
		async collectKeyword(){
			window.postMessage({greeting: "collectKeyword",startRank:this.startRank,endRank:this.endRank},"*",)
		},
		async getauthNo(){
			axios.post('/api/getAuthNo')
			.then(res => {
				this.auth = res.data.auth;
			}).catch(console.log)
		},
		checkShowItems() {
			// 키워드 분석 옵션 체크박스 처리
		},
		addKeyword(event) {
			if (event.keyCode === 13) {
				if (!this.targetKeyword) {
					return
				}

				// 콤마로 구분된 키워드들 처리
				if (this.targetKeyword.includes(',')) {
					const keywordArray = this.targetKeyword.split(',');
					let addedCount = 0;

					for (let keyword of keywordArray) {
						keyword = keyword.trim().replaceAll(" ", "");
						if (keyword.length > 0) {
							if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								});
								addedCount++;
							}
						}
					}

					if (addedCount > 0) {
						this.db.saveKeywords(this.keywords).catch(error => { console.error('키워드 저장 실패:', error); });
						// this.showlist = true;
					}

					this.targetKeyword = "";
					return;
				}

				// 기존 로직: 공백으로 구분된 키워드들 처리
				if (this.targetKeyword.length > 10 && this.targetKeyword.split(' ').length > 3) {
					for (var keyword of this.targetKeyword.split(' ')) {
						if (keyword.length > 0) {
							if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								})
							}
						}
					}
					this.db.saveKeywords(this.keywords).catch(error => { console.error('키워드 저장 실패:', error); });
					this.targetKeyword = "";
					// this.showlist = true;
					return
				}

				// 단일 키워드 처리
				if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == this.targetKeyword.replaceAll(" ", ""))) {
					if (this.targetKeyword.replaceAll(" ", "").length > 0) {
						this.keywords.push({
							keyword: this.targetKeyword.replaceAll(" ", ""),
							add: false,
							del: false,
						})
						this.db.saveKeywords(this.keywords).catch(error => { console.error('키워드 저장 실패:', error); });
					}
					this.targetKeyword = "";
					// this.showlist = true;
					return
				}
			}
		},
		collectRelKeywordEnter(event) {
			if (event.keyCode === 13) {
				this.$bvModal.hide('relKeyword');
				this.collectRelKeyword();
			}
		},
		async uploadfile(event) {
			try {
				this.showuploadspinner = true;

				const file = event.target.files[0];
				const data = await this.readFileAsync(file);
				const workbook = XLSX.read(data, { type: 'binary' });

				for (const sheetName of workbook.SheetNames) {
					const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
					console.log(roa);

					for (var e of roa) {
						if (e.키워드.length > 0) {
							var keyword = e.키워드
							if (!this.keywords.find(f => f.keyword == keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								})
							}
						}
					}
				}

				this.$nextTick(() => {
					// this.showlist = true;
					this.showspinner = false;
					this.showuploadspinner = false;
					this.$bvModal.hide('excelupload');
				});

				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});

			} catch (error) {
				alert(error.message);
				this.showuploadspinner = false;
				this.$bvModal.hide('excelupload');
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => resolve(e.target.result);
				reader.onerror = (error) => reject(error);
				reader.readAsBinaryString(file);
			});
		},
		formatDownload() {
			var arr = [];
			var myHeader = ['키워드'];

			var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

			const range = XLSX.utils.decode_range(dataWS['!ref']);
			range.e['c'] = myHeader.length - 1;
			dataWS['!ref'] = XLSX.utils.encode_range(range);

			var wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, dataWS, '키워드업로드양식');
			XLSX.writeFile(wb, '키워드업로드양식.xlsx');
		},
		downloadAnalysisResults() {
			let downloadItems = [];
			if (this.analysisSelectedItem.length > 0) {
				if (confirm(this.analysisSelectedItem.length + '개의 분석 결과를 다운로드 하시겠습니까?')) {
					downloadItems = this.analysisSelectedItem;
				}
			} else {
				if (confirm('전체 분석 결과를 다운로드 하시겠습니까?')) {
					downloadItems = this.rowlines;
				}
			}

			if (downloadItems.length > 0) {
				const processedData = downloadItems.map(item => {
					let newItem = {
						'키워드': item.targetKeyword,
						'윙상품비율': item.wingrate,
						'1p윙상품수': item.wing1p,
						'1p로켓상품수': item.rocket1p,
						'1p그로스상품수': item.growth1p,
						'광고비율': item.adrate,
						'광고상품수': item.adqty,
						'광고구좌수': item.adplace,
						'CPC단가_추천': item.cpc,
						'CPC단가_최대': item.cpchigh,
						'CPC단가_최저': item.cpclow,
						'로켓비율': item.rocketrate,
						'로켓상품수': item.rocketqty,
						'전체상품수': item.totalqty,
						'최대리뷰수': item.review1phigh,
						'평균리뷰수': item.review1p,
						'중간리뷰수': item.review1pmiddle,
						'최저리뷰수': item.review1plow,
						'최대판매가': item.price1phigh,
						'평균판매가': item.price1p,
						'중간판매가': item.price1pmiddle,
						'최저판매가': item.price1plow,
						'네이버최대판매가': item.pricen1phigh,
						'네이버평균판매가': item.pricen1p,
						'네이버중간판매가': item.pricen1pmiddle,
						'네이버최저판매가': item.pricen1plow,
						'최대월판매수': item.n1psalesqtyhigh,
						'평균월판매수': item.n1psalesqty,
						'중간월판매수': item.n1psalesqtymiddle,
						'최저월판매수': item.n1psalesqtylow,
						'최대월매출': item.n1psaleshigh,
						'평균월매출': item.n1psales,
						'중간월매출': item.n1psalesmiddle,
						'최저월매출': item.n1psaleslow,
					};
					Object.keys(newItem).forEach(key => {
						if (newItem[key] === undefined) {
							newItem[key] = '';
						}
					});
					return newItem;
				});

				const date = new Date();
				const today = date.getFullYear() +
					("0" + (1 + date.getMonth())).slice(-2) +
					("0" + date.getDate()).slice(-2);

				const workBook = XLSX.utils.book_new();
				const workSheet = XLSX.utils.json_to_sheet(processedData, {
					header: Object.keys(processedData[0])
				});

				XLSX.utils.book_append_sheet(workBook, workSheet, '키워드분석결과');
				XLSX.writeFile(workBook, '키워드분석결과_' + today + '.xlsx');
			}
		},
		deleteKeywords() {
			if (this.tableSelectedItem.length === 0) {
				alert('삭제할 키워드를 선택해주세요.');
				return;
			}

			if (confirm(`선택된 ${this.tableSelectedItem.length}개의 키워드를 삭제하시겠습니까?`)) {
				// 선택된 키워드들 제거
				const selectedKeywords = this.tableSelectedItem.map(item => item.keyword);
				this.keywords = this.keywords.filter(keyword => !selectedKeywords.includes(keyword.keyword));

				// 선택 목록 초기화
				this.tableSelectedItem = [];

				// headers 업데이트 불필요 (모든 컬럼이 처음부터 정의됨)

				// IndexedDB에 저장
				this.db.saveKeywords(this.keywords).catch(error => {
					console.error('키워드 저장 실패:', error);
				});

				// 모든 키워드가 삭제되면 목록 숨기기
				if (this.keywords.length === 0) {
					// this.showlist = false;
				}
			}
		},
		clearAllKeywords() {
			if (this.keywords.length === 0) {
				alert('삭제할 키워드가 없습니다.');
				return;
			}

			if (confirm('모든 키워드와 분석 결과를 삭제하시겠습니까?')) {
				this.keywords = [];
				this.tableSelectedItem = [];
				// this.showlist = false;

				// headers 초기화 불필요 (모든 컬럼이 처음부터 정의됨)

				// IndexedDB에서도 삭제
				this.db.saveKeywords([]).catch(error => {
					console.error('키워드 삭제 실패:', error);
				});
				this.db.saveAnalysisResults([]).catch(error => {
					console.error('분석 결과 삭제 실패:', error);
				});
			}
		},
		searchenter(event){
			if(event.keyCode === 13){
				this.search();
			}
		},
		startfocus(){
			this.$refs.cursor.focus();
		},
		middlelevel(arr) {
			arr.sort((a,b) => a-b);
			var val = parseInt(arr.length/2);
			return arr[val];
		},
		async makerowlines(coupang,naver,cpcobj){
			// 분석 결과를 실시간으로 키워드 목록에 반영
			this.rowlines.forEach((e) => {
				// console.log(coupang)
				// console.log(e)
				if(coupang.find(ele => ele.keyword == e.targetKeyword)){
					var coupang1p = coupang.find(ele => ele.keyword == e.targetKeyword);
					var coupang1plist = coupang1p.productlists1p.filter(ele => ele.ad == false);
					// console.log(coupang1plist.map(ele => ele.ratingcount))
					var naver1p = naver.find(ele => ele.keyword == e.targetKeyword).keywordvalue;
					var naverlist = naver.find(ele => ele.keyword == e.targetKeyword).products;
					// console.log(naverlist.filter(ele => ele.purchaseCnt >= 0))
					for(var j=0;j<naver1p.length;j++){
						naver1p[j].long = parseInt(naver1p[j].long > naverlist.find(ele => ele.rank == naver1p[j].rank).purchaseCnt/26 ? naver1p[j].long : naverlist.find(ele => ele.rank == naver1p[j].rank).purchaseCnt/26);

					}

					var cpc = cpcobj ? cpcobj[e.targetKeyword] : '';

					e.wing1p = coupang1plist.filter(ele => ele.type == 'wing').length;
					e.rocket1p = coupang1plist.filter(ele => ele.type == 'rocket').length;
					e.growth1p = coupang1plist.filter(ele => ele.type == 'jet').length;
					e.wingrate = (e.wing1p/(e.wing1p+e.rocket1p+e.growth1p)*100).toFixed(2);
					e.adqty = coupang1p.adqty;
					e.adplace = coupang1p.adplace;
					e.adrate = (coupang1p.adqty/coupang1p.adplace*100).toFixed(2);
					e.cpchigh = cpc ? cpc.high : 0;
					e.cpclow = cpc ? cpc.low : 0;
					e.cpc = cpc ? cpc.suggested : 0;
					e.rocketqty = coupang1p.rocketqty;
					e.totalqty = coupang1p.totalqty;
					e.rocketrate = (coupang1p.rocketqty/coupang1p.totalqty*100).toFixed(2);

					e.review1phigh = coupang1plist.reduce((pv,cv)=>{return pv > cv.ratingcount ? pv : cv.ratingcount},0);
					e.review1plow = coupang1plist.reduce((pv,cv)=>{return pv < cv.ratingcount ? pv : cv.ratingcount},100000000);
					e.review1p = Math.round(coupang1plist.reduce((pv,cv)=>{return pv + cv.ratingcount},0)/coupang1plist.length);
					e.review1pmiddle = this.middlelevel(coupang1plist.map(ele => ele.ratingcount));

					e.price1phigh = coupang1plist.reduce((pv,cv)=>{return pv > cv.price ? pv : cv.price},0);
					e.price1plow = coupang1plist.reduce((pv,cv)=>{return pv < cv.price ? pv : cv.price},100000000);
					e.price1p = Math.round(coupang1plist.reduce((pv,cv)=>{return pv + cv.price},0)/coupang1plist.length);
					e.price1pmiddle = this.middlelevel(coupang1plist.map(ele => ele.price));

					e.pricen1phigh = naver1p.reduce((pv,cv)=>{return pv > cv.price ? pv : cv.price},0);
					e.pricen1plow = naver1p.reduce((pv,cv)=>{return pv < cv.price ? pv : cv.price},100000000);
					e.pricen1p = Math.round((naver1p.reduce((pv,cv)=>{return pv + cv.price},0))/naver1p.length);
					e.pricen1pmiddle = this.middlelevel(naver1p.map(ele => ele.price));
					// e.crate = (e.review1p/e.totalqty).toFixed(2);
					e.n1psalesqtyhigh = naver1p.reduce((pv,cv)=>{return pv > cv.long ? pv : cv.long},0);
					e.n1psalesqtylow = naver1p.reduce((pv,cv)=>{return pv < cv.long ? pv : cv.long},100000000);
					e.n1psalesqty = Math.round((naver1p.reduce((pv,cv)=>{return pv + cv.long},0))/naver1p.length);
					e.n1psalesqtymiddle = this.middlelevel(naver1p.map(ele => ele.long));

					e.n1psaleshigh = naver1p.reduce((pv,cv)=>{return pv > cv.long*cv.price ? pv : cv.long*cv.price},0);
					e.n1psaleslow = naver1p.reduce((pv,cv)=>{return pv < cv.long*cv.price ? pv : cv.long*cv.price},100000000);
					e.n1psales = Math.round((naver1p.reduce((pv,cv)=>{return pv + cv.long*cv.price},0))/naver1p.length);
					e.n1psalesmiddle = this.middlelevel(naver1p.map(ele => ele.long*ele.price));

					// 실시간으로 키워드 목록에 분석 결과 반영 (keywordCollect 방식)
					const keywordItem = this.keywords.find(k => k.keyword === e.targetKeyword);
					if (keywordItem) {

						// Vue 반응성을 위해 개별 속성 할당
						keywordItem.wingrate = e.wingrate;
						keywordItem.wing1p = e.wing1p;
						keywordItem.rocket1p = e.rocket1p;
						keywordItem.growth1p = e.growth1p;
						keywordItem.adrate = e.adrate;
						keywordItem.adqty = e.adqty;
						keywordItem.adplace = e.adplace;
						keywordItem.cpc = e.cpc;
						keywordItem.cpchigh = e.cpchigh;
						keywordItem.cpclow = e.cpclow;
						keywordItem.totalqty = e.totalqty;
						keywordItem.review1p = e.review1p;
						keywordItem.review1phigh = e.review1phigh;
						keywordItem.review1plow = e.review1plow;
						keywordItem.review1pmiddle = e.review1pmiddle;
						keywordItem.price1p = e.price1p;
						keywordItem.price1phigh = e.price1phigh;
						keywordItem.price1plow = e.price1plow;
						keywordItem.price1pmiddle = e.price1pmiddle;
						keywordItem.pricen1p = e.pricen1p;
						keywordItem.pricen1phigh = e.pricen1phigh;
						keywordItem.pricen1plow = e.pricen1plow;
						keywordItem.pricen1pmiddle = e.pricen1pmiddle;
						keywordItem.n1psalesqty = e.n1psalesqty;
						keywordItem.n1psalesqtyhigh = e.n1psalesqtyhigh;
						keywordItem.n1psalesqtylow = e.n1psalesqtylow;
						keywordItem.n1psalesqtymiddle = e.n1psalesqtymiddle;
						keywordItem.n1psales = e.n1psales;
						keywordItem.n1psaleshigh = e.n1psaleshigh;
						keywordItem.n1psaleslow = e.n1psaleslow;
						keywordItem.n1psalesmiddle = e.n1psalesmiddle;
					}
				}
			})

			// 더 이상 헤더 업데이트 불필요 (모든 컬럼이 처음부터 정의됨)

			// IndexedDB에 저장
			this.db.saveAnalysisResults(this.rowlines).catch(error => {
				console.error('분석 결과 저장 실패:', error);
			});

			// keywordCollect 방식: $nextTick으로 UI 업데이트
			this.$nextTick(() => {
				this.showlist = true;
				this.showspinner = false;
			});

		},
		async sleep(ms) {
			return new Promise((r) => setTimeout(r, ms));
		},
		async importresults(arr){
			await this.sleep(1000);
			this.loadingtext = '데이터 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
			// 테이블을 숨기지 않고 유지하여 실시간 업데이트 확인 가능
			window.postMessage({greeting: "keywordanalysis",data:arr,auth:this.auth, ad:this.check2},"*",)
			// // this.waitresult = false;
			// for(var i=0;i<this.rowlines.length;i++){
			// 	var e = this.rowlines[i];
			// 	await this.sleep(1000)
			// 	if(e.targetKeyword || e.productName || e.itemId || e.productId || e.vendorItemId){
			// 		e.showspinner = true;
			// 		e.rank = [];
			// 		e.adqty = '';
			// 		e.adplace = '';
			// 		e.productqty = '';
			// 		e.rocketqty = '';
			// 		e.totalrank = [];
			// 		var data = {
			// 			targetKeyword : e.targetKeyword,
			// 			productName : e.productName,
			// 			itemId : e.itemId,
			// 			productId : e.productId,
			// 			vendorItemId : e.vendorItemId,
			// 			index : i,
			// 			fullsearch : false,
			// 		}
			// 		// console.log(data)
			// 		window.postMessage({greeting: "coupangrank",data:data},"*",)
			// 		// this.waitresult = true;
			// 	}
			// }
			// // this.waitresult = false;
		},
		changelines(){
			this.rowlines = [];
			for(var i=0;i<this.addlines;i++){
				this.rowlines.push({targetKeyword:'',productName:'',itemId:'',productId:'',vendorItemId:'',rank:[],adqty:'',adplace:'',productqty:'',rocketqty:'',showspinner:false,totalrank:[]})
			}
		},
		resetitem(i){
			this.rowlines[i].targetKeyword = '';
			this.rowlines[i].productName = '';
			this.rowlines[i].itemId = '';
			this.rowlines[i].productId = '';
			this.rowlines[i].rank = [];
			this.rowlines[i].adqty = '';
			this.rowlines[i].adplace = '';
			this.rowlines[i].productqty = '';
			this.rowlines[i].rocketqty = '';
			this.rowlines[i].showspinner = false;
			this.rowlines[i].totalrank = [];
		},
		downloadKeywords() {
			let downloadItems = [];
			let fileName = "키워드분석";

			// 선택된 항목이 있으면 선택된 항목만, 없으면 전체 다운로드
			if (this.tableSelectedItem.length > 0) {
				if (confirm(`선택된 ${this.tableSelectedItem.length}개의 키워드를 다운로드 하시겠습니까?`)) {
					downloadItems = this.tableSelectedItem;
					fileName += "_선택항목";
				} else {
					return;
				}
			} else {
				if (confirm('전체 키워드 분석 결과를 다운로드 하시겠습니까?')) {
					downloadItems = this.keywords;
				} else {
					return;
				}
			}

			if (downloadItems.length === 0) {
				alert('다운로드할 데이터가 없습니다.');
				return;
			}

			// 엑셀 다운로드 처리
			const exportData = downloadItems.map(item => {
				const obj = { 키워드: item.keyword };

				// 모든 분석 결과 항목 포함
				if (item.wingrate !== undefined) obj['윙상품비율(%)'] = item.wingrate;
				if (item.wing1p !== undefined) obj['1p윙상품수'] = item.wing1p;
				if (item.rocket1p !== undefined) obj['1p로켓상품수'] = item.rocket1p;
				if (item.growth1p !== undefined) obj['1p그로스상품수'] = item.growth1p;
				if (item.adrate !== undefined) obj['광고비율(%)'] = item.adrate;
				if (item.adqty !== undefined) obj['광고상품수'] = item.adqty;
				if (item.adplace !== undefined) obj['광고구좌수'] = item.adplace;
				if (item.cpc !== undefined) obj['CPC단가_추천'] = item.cpc;
				if (item.cpchigh !== undefined) obj['CPC단가_최대'] = item.cpchigh;
				if (item.cpclow !== undefined) obj['CPC단가_최저'] = item.cpclow;
				if (item.totalqty !== undefined) obj['전체상품수'] = item.totalqty;
				if (item.review1phigh !== undefined) obj['최대리뷰수'] = item.review1phigh;
				if (item.review1p !== undefined) obj['평균리뷰수'] = item.review1p;
				if (item.review1pmiddle !== undefined) obj['중간리뷰수'] = item.review1pmiddle;
				if (item.review1plow !== undefined) obj['최저리뷰수'] = item.review1plow;
				if (item.price1phigh !== undefined) obj['최대판매가'] = item.price1phigh;
				if (item.price1p !== undefined) obj['평균판매가'] = item.price1p;
				if (item.price1pmiddle !== undefined) obj['중간판매가'] = item.price1pmiddle;
				if (item.price1plow !== undefined) obj['최저판매가'] = item.price1plow;
				if (item.pricen1phigh !== undefined) obj['네이버최대판매가'] = item.pricen1phigh;
				if (item.pricen1p !== undefined) obj['네이버평균판매가'] = item.pricen1p;
				if (item.pricen1pmiddle !== undefined) obj['네이버중간판매가'] = item.pricen1pmiddle;
				if (item.pricen1plow !== undefined) obj['네이버최저판매가'] = item.pricen1plow;
				if (item.n1psalesqtyhigh !== undefined) obj['최대월판매수'] = item.n1psalesqtyhigh;
				if (item.n1psalesqty !== undefined) obj['평균월판매수'] = item.n1psalesqty;
				if (item.n1psalesqtymiddle !== undefined) obj['중간월판매수'] = item.n1psalesqtymiddle;
				if (item.n1psalesqtylow !== undefined) obj['최저월판매수'] = item.n1psalesqtylow;
				if (item.n1psaleshigh !== undefined) obj['최대월매출'] = item.n1psaleshigh;
				if (item.n1psales !== undefined) obj['평균월매출'] = item.n1psales;
				if (item.n1psalesmiddle !== undefined) obj['중간월매출'] = item.n1psalesmiddle;
				if (item.n1psaleslow !== undefined) obj['최저월매출'] = item.n1psaleslow;

				return obj;
			});

			function getToday(){
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);
				return year + month + day;
			}

			const ws = XLSX.utils.json_to_sheet(exportData);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "키워드분석");
			XLSX.writeFile(wb, fileName + "_" + getToday() + ".xlsx");
		},
		search(){
			if(this.keywords.length === 0){
				alert('분석할 키워드를 먼저 추가해 주세요')
				return
			}
			if(!this.check1 && !this.check2 && !this.check3){
				alert('분석 옵션을 하나 이상 선택해 주세요')
				return
			}

			// 선택된 키워드들 또는 전체 키워드들을 분석 대상으로 설정
			let keywordsToAnalyze = [];
			if(this.tableSelectedItem.length > 0){
				keywordsToAnalyze = this.tableSelectedItem.map(item => item.keyword);
			} else {
				keywordsToAnalyze = this.keywords.map(item => item.keyword);
			}

			if(confirm(keywordsToAnalyze.length + '개의 키워드를 분석하시겠습니까?')){
				// 분석할 키워드들을 임시 rowlines 배열 생성
				this.rowlines = [];
				for(var keyword of keywordsToAnalyze){
					this.rowlines.push({
						targetKeyword: keyword,
						wing1p:'',
						rocket1p:'',
						growth1p:'',
						adrate:'',
						adqty:'',
						adplace:'',
						cpc:'',
						cpchigh:'',
						cpclow:'',
						rocketrate:'',
						rocketqty:'',
						totalqty:'',
						crate:'',
						review1p:'',
						review1phigh:'',
						review1plow:'',
						review1pmiddle:'',
						n1psalesqty:'',
						n1psalesqtyhigh:'',
						n1psalesqtylow:'',
						n1psalesqtymiddle:'',
						n1psales:'',
						n1psaleshigh:'',
						n1psaleslow:'',
						n1psalesmiddle:'',
						nrate:'',
						wingrate:'',
						price1p:'',
						price1phigh:'',
						price1plow:'',
						price1pmiddle:'',
						pricen1p:'',
						pricen1phigh:'',
						pricen1plow:'',
						pricen1pmiddle:'',
					})
				}
				this.importresults(keywordsToAnalyze)
			}
		},

		download() {
			function getToday(){
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);

				return year + month + day;
			}
			var arr = [];
			this.rowlines.forEach(e => {
				arr.push({
					키워드 : e?.targetKeyword,
					쿠팡1p윙비율:e?.wingrate,
					쿠팡1p윙제품수 : e?.wing1p,
					쿠팡1p로켓제품수 : e?.rocket1p,
					쿠팡1p그로스제품수 : e?.growth1p,
					쿠팡광고비율 : e?.adrate,
					쿠팡광고상품수 : e?.adqty,
					쿠팡광고구좌수: e?.adplace,
					쿠팡광고CPC단가_추천: e?.cpc,
					쿠팡광고CPC단가_최대: e?.cpchigh,
					쿠팡광고CPC단가_최저: e?.cpclow,
					쿠팡로켓비율: e?.rocketrate,
					쿠팡로켓상품수: e?.rocketqty,
					쿠팡전체상품수: e?.totalqty,

					쿠팡1p리뷰수_평균: e?.review1p,
					쿠팡1p리뷰수_최대: e?.review1phigh,
					쿠팡1p리뷰수_최저: e?.review1plow,
					쿠팡1p리뷰수_중간: e?.review1pmiddle,

					쿠팡1p판매가_평균: e?.price1p,
					쿠팡1p판매가_최대: e?.price1phigh,
					쿠팡1p판매가_최저: e?.price1plow,
					쿠팡1p판매가_중간: e?.price1pmiddle,

					네이버1p판매가_평균: e?.pricen1p,
					네이버1p판매가_최대: e?.pricen1phigh,
					네이버1p판매가_최저: e?.pricen1plow,
					네이버1p판매가_중간: e?.pricen1pmiddle,

					네이버1p월판매수량_평균: e?.n1psalesqty,
					네이버1p월판매수량_최대: e?.n1psalesqtyhigh,
					네이버1p월판매수량_최저: e?.n1psalesqtylow,
					네이버1p월판매수량_중간: e?.n1psalesqtymiddle,
					네이버1p월매출_평균: e?.n1psales,
					네이버1p월매출_최대: e?.n1psaleshigh,
					네이버1p월매출_최저: e?.n1psaleslow,
					네이버1p월매출_중간: e?.n1psalesmiddle,					
				})
			})
			const workBook = XLSX.utils.book_new()
			const workSheet1 = XLSX.utils.json_to_sheet(arr)
			XLSX.utils.book_append_sheet(workBook, workSheet1, '키워드분석')
			XLSX.writeFile(workBook, '키워드분석' + '_' + getToday() + '.xlsx')
		}
	}

}
</script>

<style scoped>
.my-class .dropdown-menu {

max-height: 300px;
width:800px;
overflow-y: auto;
}
.modal-dialog {
    max-width: 90%;
    position: absolute;
    
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>